import React from "react";
import { ISVGProps } from "types";

export default function Clubic(props: ISVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 101 53"
            className="mentions-ticker-element"
        >
            <g clipPath="url(#a)" opacity={0.75}>
                <path
                    style={{
                        fill: "#939393",
                    }}
                    fillRule="evenodd"
                    d="M6.04 52.69h89.49a4.983 4.983 0 0 0 4.983-4.976c.018-12.06.084-41.875.084-41.875 0-2.74-2.243-4.984-4.984-4.984H6.04A4.999 4.999 0 0 0 1.056 5.84v41.867a4.998 4.998 0 0 0 4.983 4.983Zm64.4-37.342h3.7v2.79h-3.7v-2.79Zm0 5.292h3.7v15.504h-3.7V20.64Zm-24.97 9.795c0 2.07-1.832 2.984-2.982 2.984-1.391 0-2.983-1.057-2.983-2.984V20.64h-3.699s.027 6.175.027 9.795 2.878 5.969 5.967 5.969c2.226 0 3.67-1.263 3.67-1.263v1.002h3.7V20.64h-3.7v9.795Zm-25.974 2.271a4.316 4.316 0 0 1-.624-8.585 4.308 4.308 0 0 1 3.182.798c.673.496 1.723.503 2.368-.028l1.525-1.251a8.002 8.002 0 0 0-6.833-3.252c-4.026.186-7.335 3.414-7.613 7.435a8.014 8.014 0 0 0 13.992 5.882l-1.191-1.37a1.868 1.868 0 0 0-2.437-.338c-.68.45-1.495.71-2.37.71Zm60.956-4.546a4.314 4.314 0 0 0 4.309 4.548c.887 0 1.71-.269 2.396-.727a1.888 1.888 0 0 1 2.472.333l1.17 1.345a8.015 8.015 0 0 1-14.032-5.836c.28-4.054 3.64-7.295 7.702-7.439a7.993 7.993 0 0 1 6.33 2.74l-1.17 1.346c-.63.725-1.694.847-2.497.318a4.31 4.31 0 0 0-2.734-.695c-2.125.173-3.835 1.938-3.946 4.067Zm-24.676.232c0 2.613 1.85 4.732 4.13 4.732 2.282 0 4.13-2.12 4.13-4.732 0-2.613-1.85-4.732-4.13-4.732s-4.13 2.119-4.13 4.732Zm.53-6.528c1.193-.935 2.652-1.485 4.23-1.485 4.03 0 7.295 3.586 7.295 8.012 0 4.425-3.266 8.013-7.295 8.013-1.578 0-3.037-.55-4.23-1.484v1.224h-3.7V15.348h3.7v6.516Zm-23.977-6.516h-3.7v20.796h3.7V15.348Z"
                    clipRule="evenodd"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path
                        style={{
                            fill: "#939393",
                        }}
                        d="M.933.725h99.8v52.094H.933z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
